import { Button } from "@/components/ui/button";
import { Product } from "../types";
import { Price } from "./price";
import { useState } from "react";
import VariantSelectorDrawer from "./variant-selector-drawer";

export default function ProductCardSmall({ product }: { product: Product }) {
  const [openDrawer, setDrawer] = useState(false);

  function toggle(override?: boolean) {
    setDrawer((prev) => (typeof override === "boolean" ? override : !prev));
  }

  const hasDiscount =
    product.compareAtPriceRange?.maxVariantPrice?.amount ===
    product.priceRange.maxVariantPrice.amount;
  return (
    <div className="h-36 min-w-[80%] max-w-[80%] self-stretch overflow-hidden border border-black md:min-w-[50%] md:max-w-[50%]">
      <div className="hp-flex hp-h-full hp-items-stretch">
        <div className="w-[30%] shrink-0 bg-black">
          <div className="hp-relative hp-flex hp-h-full hp-w-full hp-justify-center">
            <img
              src={product.image}
              alt={product.title}
              className="hp-aspect-square hp-w-full hp-object-cover hp-object-center"
            />
          </div>
        </div>
        <div className="flex-1 bg-card pb-3 pl-5 pt-3.5">
          <div className="hp-flex hp-flex-col hp-justify-between hp-gap-2 hp-overflow-hidden">
            <h2 className="hp-line-clamp-2 hp-overflow-hidden hp-text-base hp-font-normal hp-text-gray-800">
              {product.title}
            </h2>
            <div className="hp-flex hp-items-center hp-gap-3 hp-text-sm">
              <Price
                hidden={hasDiscount}
                className={`line-through`}
                amount={
                  product.compareAtPriceRange?.maxVariantPrice?.amount ?? 0
                }
                currencyCode={
                  product.compareAtPriceRange?.maxVariantPrice?.currencyCode ??
                  "INR"
                }
              />
              <Price
                amount={product.priceRange?.minVariantPrice?.amount ?? 0}
                currencyCode={
                  product?.priceRange?.minVariantPrice?.currencyCode ?? "INR"
                }
              />
              <div
                className={`rounded-full bg-primary px-1.5 text-[0.5rem] text-primary-foreground ${product.priceRange?.minVariantPrice?.amount === product.priceRange?.maxVariantPrice?.amount ? "hidden" : ""}`}
              >
                {(
                  ((product?.compareAtPriceRange?.maxVariantPrice?.amount -
                    product?.priceRange?.minVariantPrice?.amount) *
                    100) /
                  product?.priceRange?.maxVariantPrice?.amount
                ).toFixed(0) || 0}
                %off
              </div>
            </div>
            <Button
              className="mt-1 h-6 w-24 rounded-xl bg-primary px-2.5 py-2 text-sm font-normal"
              onClick={() => toggle()}
            >
              Add to Cart
            </Button>
          </div>
        </div>
      </div>
      <VariantSelectorDrawer
        product={product}
        open={openDrawer}
        toggle={toggle}
      />
    </div>
  );
}
